import { render, staticRenderFns } from "./SfRating.vue?vue&type=template&id=643eca84&functional=true"
import script from "./SfRating.vue?vue&type=script&lang=js"
export * from "./SfRating.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfRating.vue?vue&type=style&index=0&id=643eca84&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "7cff29c7"
  
)

export default component.exports